module.exports = __webpack_public_path__ + "static/media/plus.7fba5420.svg";